module.exports = __webpack_public_path__ + "img/js-logo.ca21a60e.svg";